export const GET_QUESTIONS_LOADING = "GET_QUESTIONS_LOADING";
export const GET_QUESTIONS_SUCCESS = "GET_QUESTIONS_SUCCESS";
export const GET_QUESTIONS_FAILURE = "GET_QUESTIONS_FAILURE";

export const SUBMIT_RESPONSE_LOADING = "SUBMIT_RESPONSE_LOADING";
export const SUBMIT_RESPONSE_SUCCESS = "SUBMIT_RESPONSE_SUCCESS";
export const SUBMIT_RESPONSE_FAILURE = "SUBMIT_RESPONSE_FAILURE";
